import { useOAuth2UrlLazyQuery } from 'graph/generated/payments/graphql-types'
import { replaceStateParamWithRedirectUrl } from 'utils/ory'
import { validateRedirectUrlOrRelative } from 'utils/security'

import Button from '@/ui/Button'
/**
 * @returns a button that will get redirect link to auth app from hydra
 * so user will be able to login and be redirected back to payments app
 */

interface ILoginButton {
  redirectTo?: string
}

const LoginButton = ({ redirectTo }: ILoginButton) => {
  const [getOAuth2Url] = useOAuth2UrlLazyQuery()

  const handleLogin = async () => {
    const url = await getOAuth2Url()
    const oauthUrl = url?.data?.OAuth2Url
    if (!oauthUrl) return
    // Validate redirectTo before embedding in state param
    const safeRedirect = redirectTo
      ? validateRedirectUrlOrRelative(redirectTo)
      : null
    // OAuth2Url from Hydra — validate protocol inline (see packages/utils/security/index.ts)
    try {
      const parsed = new URL(oauthUrl)
      if (!['https:', 'http:'].includes(parsed.protocol)) return
    } catch {
      return
    }
    window.location.href = safeRedirect
      ? replaceStateParamWithRedirectUrl(oauthUrl, safeRedirect)
      : oauthUrl
  }
  return <Button onClick={handleLogin}>Login</Button>
}

export default LoginButton
